import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Button, LottiePlayer } from '@repo/design-system-kit';
import styles from './styles.module.css';

interface PricingErrorProps {
  onRetry: () => void;
}

export function PricingError({ onRetry }: PricingErrorProps): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.wrapper} data-test-pricing-error>
      <LottiePlayer
        className={styles.illustration}
        data-test-pricing-error-lottie
        loop={false}
        path="/illustrations/lottie/connection-error.json"
      />
      <h1 className={styles.title} data-test-pricing-error-title>
        {formatMessage({ id: 'price_plan.choose-plan.error.title' })}
      </h1>
      <p className={styles.description} data-test-pricing-error-description>
        {formatMessage({ id: 'price_plan.choose-plan.error.description' })}
      </p>
      <Button data-test-pricing-error-cta onPress={onRetry} stretch type="button" variant="primary">
        {formatMessage({ id: 'price_plan.choose-plan.error.cta' })}
      </Button>
    </div>
  );
}
